import { formatFileSize, useCSVReader } from "react-papaparse";

export default function CSVReader({ sendData, rejectData, removeFile }) {
    const { CSVReader } = useCSVReader();

    const uploadAccept = (e, file) => {
        sendData(e, file)
    }
    const uploadReject = ([{ file }]) => {
        // console.log('uploadReject', file)
        rejectData(file.name.split('.')[1])
    }

    return (
        <CSVReader
            onUploadAccepted={uploadAccept}
            onUploadRejected={uploadReject}

            accept=".csv, .xls, .xlsx"
        >
            {({
                getRootProps,
                acceptedFile,
                ProgressBar,
                getRemoveFileProps,
                Remove
            }) => (
                <div
                    {...getRootProps()}
                    className="
                    leading-none 
                    text-black 
                    bg-green-200 
                    items-center 
                    border-2 
                    border-dashed 
                    border-gray-900/50 
                    rounded-2xl 
                    flex 
                    flex-col 
                    justify-center 
                    p-4 
                    w-[11rem] 
                    h-[11rem] 
                    cursor-pointer 
                    m-auto
                    "
                >
                    {acceptedFile ?
                        <div
                            className="border-2 rounded-2xl relative w-[9rem] h-[9rem] flex flex-col justify-center "
                            style={{
                                background: 'linear-gradient(to bottom, #EEEEEE, #DDDDDD)',
                                zIndex: 10,
                            }}
                        >
                            <div
                                className="items-center flex flex-col px-2">
                                <span className="bg-gray-500/40 rounded-sm mb-[.2em] flex justify-center">
                                    {formatFileSize(acceptedFile.size)}
                                </span>
                                <span className="w-full text-center justify-center bg-gray-500/40 rounded-sm font-xs mb-[.3em] p-[1px] break-words">{acceptedFile.name}</span>
                            </div>
                            <div
                                className="absolute w-full px-2"
                                style={{
                                    bottom: 14
                                }}>
                                <ProgressBar />
                            </div>
                            <div
                                {...getRemoveFileProps()}
                                onClick={(e) => { removeFile(); getRemoveFileProps().onClick(e) }}
                                className="w-6 h-6 absolute "
                                style={{
                                    right: 6,
                                    top: 6,
                                }}
                            >
                                <Remove />
                            </div>
                        </div>
                        :
                        <div>
                            <span className="underline font-bold">Clique aqui</span> ou
                            <span className="underline font-bold"> arraste e solte</span> o documento nesta área para carregar.
                            <br /> <br />
                            <span className="text-sm font-bold">
                                *arquivo não deve exceder 20MB
                            </span>
                        </div>
                    }
                </div>
            )
            }
        </CSVReader >
    );
}